module.exports = __webpack_public_path__ + "img/Verpflegungstrupp.36f272a5.svg";